import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Paper, Grid, Card, CardContent } from '@material-ui/core';
import AppsIcon from '@material-ui/icons/Apps';
import CloudIcon from '@material-ui/icons/Cloud';
import SchoolIcon from '@material-ui/icons/School';
import SpeedIcon from '@material-ui/icons/Speed';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(4)
	},
	header: {
		textAlign: 'center',
		marginBottom: theme.spacing(6)
	},
	featureCard: {
		height: '100%',
		textAlign: 'center',
		padding: theme.spacing(3)
	},
	icon: {
		fontSize: 60,
		color: theme.palette.primary.main,
		marginBottom: theme.spacing(2)
	}
}));

const defaultFeatures = [
	{
		icon: AppsIcon,
		title: 'Rich Application Library',
		description: 'Access a wide range of educational and professional applications'
	},
	{
		icon: CloudIcon,
		title: 'Cloud Computing',
		description: 'Leverage powerful cloud infrastructure for your workloads'
	},
	{
		icon: SchoolIcon,
		title: 'Education Focused',
		description: 'Purpose-built tools for teaching and learning'
	},
	{
		icon: SpeedIcon,
		title: 'High Performance',
		description: 'Experience fast, reliable computing resources'
	}
];

function FeatureGrid({ config = {}, branding = {} }) {
	const classes = useStyles();

	const {
		title = 'Platform Features',
		subtitle = 'Discover what makes Heidi Platform powerful',
		features = defaultFeatures
	} = config;

	return (
		<Paper className={classes.root}>
			<div className={classes.header}>
				<Typography variant="h3" gutterBottom>
					{title}
				</Typography>
				<Typography variant="h6" color="textSecondary">
					{subtitle}
				</Typography>
			</div>

			<Grid container spacing={4}>
				{features.map((feature, index) => {
					const Icon = feature.icon || AppsIcon;
					return (
						<Grid item xs={12} sm={6} md={3} key={index}>
							<Card className={classes.featureCard}>
								<CardContent>
									<Icon className={classes.icon} />
									<Typography variant="h6" gutterBottom>
										{feature.title}
									</Typography>
									<Typography variant="body2" color="textSecondary">
										{feature.description}
									</Typography>
								</CardContent>
							</Card>
						</Grid>
					);
				})}
			</Grid>
		</Paper>
	);
}

export default FeatureGrid;
